import { Avatar, Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { resetState, selectLoggedInUser } from "../features/auth/auth.slice";
import React from "react";
import theme from "../app/app-theme";
import { useNavigate } from "react-router";
import { PermissionCode, UserType } from "../shared/enums";
import MemberQrCard from "./member-qr-card";
import { LogoutIcon, PasswordIcon, PersonIcon, QrIcon, SettingsIcon } from "../shared/icons";
import { getPermissionsForLoggedInUser } from "../shared/utils";

const ProfileMenu = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const loggedInUserDetails = useAppSelector(selectLoggedInUser);
    const permissions = getPermissionsForLoggedInUser(loggedInUserDetails);

    // const [showProfile, setShowProfile] = React.useState(false);
    const [showQR, setShowQR] = React.useState(false);

    const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);

    const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElUser(event.currentTarget);
    };

    const handleCloseUserMenu = () => {
        // setShowProfile(false);
        setAnchorElUser(null);
    };

    const handleProfileClick = () => {
        // setShowProfile(true);
        navigate('/profile');
        setAnchorElUser(null);
    };

    const handleChangePassword = () => {
        setAnchorElUser(null);
        navigate('/change-password');
    };

    const handleSettings = () => {
        setAnchorElUser(null);
        navigate('/settings');
    };

    const handleQR = () => {
        setAnchorElUser(null);
        setShowQR(true);
    };

    const handleLogout = () => {
        localStorage.clear();
        dispatch(resetState());
        navigate('/');
        handleCloseUserMenu();
    }

    // const handleSubmit = (data: BusinessUserRequest) => {
    //     loggedInUser && dispatch(updateUser({ ...data, id: loggedInUser.id })).then(resp => {
    //         if (resp.meta.requestStatus === 'fulfilled') {
    //             setShowProfile(false);
    //             dispatch(getLoggedInUser());
    //         }
    //     });
    // };

    const getUserBasedOnType = () => {
        if (loggedInUserDetails?.type === UserType.BUSINESS_USER) {
            return loggedInUserDetails?.roleData?.businessUser;
        } else if (loggedInUserDetails?.type === UserType.MEMBER) {
            return loggedInUserDetails?.roleData?.member;
        } else if (loggedInUserDetails?.type === UserType.GYMINIFY) {
            return loggedInUserDetails?.roleData?.admin;
        }
    }

    return (
        <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
                <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar sx={{ bgcolor: theme.palette.primary.main }}>{`${getUserBasedOnType()?.firstName[0]?.toUpperCase()}${getUserBasedOnType()?.lastName[0]?.toUpperCase()}`}</Avatar>
                </IconButton>
            </Tooltip>
            <Menu
                sx={{ mt: '45px' }}
                id="menu-appbar"
                anchorEl={anchorElUser}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={Boolean(anchorElUser)}
                onClose={handleCloseUserMenu}
            >
                <MenuItem key={'profile'} onClick={handleProfileClick}>
                    <ListItemIcon><PersonIcon sx={{ marginRight: '8px' }} /></ListItemIcon>
                    <ListItemText primary="Profile" />
                </MenuItem>
                <MenuItem key={'changePassword'} onClick={handleChangePassword}>
                    <ListItemIcon><PasswordIcon sx={{ marginRight: '8px' }} /></ListItemIcon>
                    <ListItemText primary="Change Password" />
                </MenuItem>
                {permissions.includes(PermissionCode.SETTINGS_VIEW) &&
                    <MenuItem key={'settings'} onClick={handleSettings}>
                        <ListItemIcon><SettingsIcon sx={{ marginRight: '8px' }} /></ListItemIcon>
                        <ListItemText primary="Settings" />
                    </MenuItem>
                }
                {loggedInUserDetails?.type === UserType.MEMBER &&
                    <MenuItem key={'settings'} onClick={handleQR}>
                        <ListItemIcon><QrIcon sx={{ marginRight: '8px' }} /></ListItemIcon>
                        <ListItemText primary="View QR" />
                    </MenuItem>
                }
                <MenuItem key={'logout'} onClick={handleLogout}>
                    <ListItemIcon><LogoutIcon sx={{ marginRight: '8px' }} /></ListItemIcon>
                    <ListItemText primary="Logout" />
                </MenuItem>
            </Menu>
            {/* {showProfile && loggedInUserDetails &&
                <UserForm userType={loggedInUserDetails.type} user={getUserBasedOnType()} editable={true} onClose={() => setShowProfile(false)} />
            } */}
            {showQR && loggedInUserDetails?.type === UserType.MEMBER &&
                loggedInUserDetails?.roleData?.member &&
                <MemberQrCard qrToken={loggedInUserDetails.roleData.member.qrToken} open={showQR} onClose={() => setShowQR(false)} />
            }
        </Box>
    );
}

export default ProfileMenu;